import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ModalComponent} from './modal.component';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {LayoutModule} from '../../layout-components/layout.module';
import {IconsModule} from '@lab365/icons';

@NgModule({
    declarations: [ModalComponent],
    exports: [ModalComponent],
    imports: [CommonModule, DirectivesModule, LayoutModule, IconsModule],
    providers: []
})
export class ModalModule {}
